"use strict";
require('hacktimer');
require('bootstrap');
require('bootstrap-css');
require('webpack-jquery-ui');
require('webpack-jquery-ui/css');
require('../../../ui/js/chart.min.js');
require('../../../ui/js/jquery-ui.js');
require('../../../ui/js/jquery.mCustomScrollbar.js');
require('../../../ui/js/charts.js');
window['lang'] = getUrlParam('lang');
require('../../../ui/js/language.js');
require('../js/script.js');
require('../js/charts.js');
require('../js/menu.js');
require('../js/horseracing.js');
require('../../../ui/js/iframe-script.js');
window['API_URL'] = API_URL;
window['$'] = require('jquery');
window['jquery'] = window['$'];
window['jQuery'] = window['$'];
require.context('../img', true, /\.(gif|png|jpe?g|svg)$/i);
require('../scss/' + CSS_THEME + '.scss');
switch (window.location.hostname) {
    case 'online.elbetdev.com':
        try {
            require('../scss/' + CSS_THEME + '/' + BABAIJEBU_DOMAIN + '.scss');
        }
        catch (e) {
            console.info(e);
        }
        break;
    case BABAIJEBU_DOMAIN:
        try {
            require('../scss/' + CSS_THEME + '/' + BABAIJEBU_DOMAIN + '.scss');
        }
        catch (e) {
            console.info(e);
        }
        break;
    case AMELCO_DOMAIN:
        try {
            require('../scss/' + CSS_THEME + '/' + AMELCO_DOMAIN + '.scss');
        }
        catch (e) {
            console.info(e);
        }
        break;
}
require('../../../ui/css/jquery.mCustomScrollbar.css');
window['customLoggedIn'] = false;
window['customToken'] = '';
window['token'] = getUrlParam('token');
function getUrlParam(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
        return null;
    }
    else {
        return decodeURI(results[1]) || 0;
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/games/horse-racing/ts/main.ts
// module id = 1567
// module chunks = 7